import { observer } from 'mobx-react-lite'
import { FC, Suspense, useEffect } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router'
import HeaderPerAppMode from '../../features/navigation/header/HeaderPerAppMode'
import { useUserStore } from '../../store/user/UserStore'
import Footer from '../../routes/Footer'
import { StorageKeys } from 'common'
import { usePreventRefreshDuringOrder } from 'cart'
import UserInfoServiceProvider from '../../services/UserInfoServiceProvider'
import { IS_INTEGRATED_VERSION } from '../../config/ConfigManager'
import { ModalNotification } from '../../ui-components'
import DuplicateVehicleModal from '../../store/cart/DuplicateVehicleModal'
import { DiscardAndStartNewOrder } from '../../store/cart/DiscardAndStartNewOrder'
import DDSUnavialbleDrawer from '../../features/orderHistory/components/ddsAdvancedTracker/DDSUnavialableDrawer'
import { AppLoader } from './AppLoader'
import OrgGrid from '../../features/login/Salespad/OrgGrid'

export const AppLayout: FC = observer(() => {
  usePreventRefreshDuringOrder()
  const userStore = useUserStore()
  const location = useLocation()
  const navigate = useNavigate()
  const { salesPadOrgs } = userStore

  const isIntegratedVersion = IS_INTEGRATED_VERSION
  const isUserImpersonated = localStorage.getItem(
    StorageKeys.AUTO_LOGIN_IMPERSONATION_KEY
  )

  // Auto accept EULA once the user logs in as we are not allowing users to login without accepting EULA.
  useEffect(() => {
    if (
      userStore.preferences.userId &&
      (userStore.preferences?.EULA_accepted || '').toLowerCase() !== 'true' &&
      isUserImpersonated !== 'true' &&
      !isIntegratedVersion
    ) {
      UserInfoServiceProvider.acceptTermsAndConditions()
    }

    // If the user is not logged in, save the current path so that the user can be redirected back after login.
    if (userStore.userHasLoaded && !userStore.preferences.userId) {
      localStorage.setItem(
        StorageKeys.POST_LOGIN_REDIRECT,
        `${location.pathname}${location.search}`
      )
      navigate('/login')
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (userStore.userHasLoaded && !userStore.preferences.userId) {
    return null
  }

  if (salesPadOrgs?.length > 0) {
    return <OrgGrid orgs={salesPadOrgs} />
  }

  return (
    <>
      <HeaderPerAppMode />
      <Suspense fallback={<AppLoader />}>
        <Outlet />
      </Suspense>
      <ModalNotification />
      <DuplicateVehicleModal />
      <DiscardAndStartNewOrder />
      <DDSUnavialbleDrawer />
      <Footer />
    </>
  )
})
